import { t } from '@citrite/translate';
import { AppsIcon, AppsSolidIcon } from '@citrite/web-ui-component';
import { LeftNavPositions } from '@citrite/workspace-ui-platform';
import { checkAppsAvailability } from 'App/Navigation/checkAppsAvailability';
import { Apps } from 'App/Screen';
import { performance } from 'Components/performance';
import { createLeftNavRoute } from 'Router/ReactRoute';

export const appsPagePath = '/apps';

export const appsRoute = createLeftNavRoute({
	component: Apps,
	path: appsPagePath,
	isAvailable: props => checkAppsAvailability(props),
	isLoading: props => props.resources.loading,
	getNavLinkProps: () => ({
		icon: AppsIcon,
		selectedIcon: AppsSolidIcon,
		title: t('Workspace:apps'),
		weight: LeftNavPositions.apps,
		performanceMark: performance.events.MobileAppsLink_Click,
		analyticsID: 'leftnav-apps-tab',
	}),
	pathParams: undefined,
});
